// Google Analytics 4 utility functions

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (typeof window !== 'undefined' && !window.gtag) {
    // Add Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', measurementId, {
      page_path: window.location.pathname,
    });
  }
};

// Track page view
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Track unique visitor (this is automatically handled by GA, but we can track custom events)
export const trackVisitor = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Check if this is a new session
    const isNewSession = !sessionStorage.getItem('ga_session_started');
    if (isNewSession) {
      sessionStorage.setItem('ga_session_started', 'true');
      trackEvent('session_start', {
        event_category: 'engagement',
        event_label: 'New Session',
      });
    }
  }
};

